/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:4f60f050-97c3-4697-8257-9a05b32979be",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_tCgVBKP8A",
    "aws_user_pools_web_client_id": "190id7bunkvmvgm7qg14fdrddc",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://3denfkkacfbvray74xtqskltpe.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_appsync_apiKey": "da2-iplgnkiwgfczfb7peqzdscldia",
    "aws_cloud_logic_custom": [
        {
            "name": "appCommandApi",
            "endpoint": "https://v1qt5s5db1.execute-api.us-east-2.amazonaws.com/stg",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
